<template>
  <button
    @click.prevent="onclick"
    class="d-flex menu-button"
    :class="{ disabled: disabled, locked: locked }"
  >
    <slot></slot>
  </button>
</template>
<script>

export default {
  data() {
    return {
      hover: false,
    };
  },
  components: {
  },
  props: {
    lockable: Boolean,
    locked: Boolean,
    disabled: Boolean,
  },
  methods: {
    onclick: function(e) {
      this.$emit("click", e);
    },
    toggle: function() {
      this.expanded = !this.expanded;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/stranger.scss';

.menu-button {
  width: 100%;
  height: 37px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  padding-inline: 10px;
  font-family: "Amiga4ever";
  font-size: 12px;  

  &.disabled {
    color: #ffffff5f;
    pointer-events: none;
  }
}

@media (max-width: 600px) {
  .menu-button {
    height: 45px;
  }
}
</style>
